import { schema } from "normalizr";

import { unit } from "shared/state/Unit/schema";

export const unitListing = new schema.Entity("unitListing", {
  unit,
});
export const unitListings = [unitListing];
